import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const ConfirmResetPasswordPageStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100%;
    flex-wrap: wrap;
  `,
  Title: styled.p<any>`
    margin-bottom: 30px;
    text-align: center;
    font-family: EncodeSans-Medium;
    font-size: 16px;
  `,
  ContainerForm: styled(Grid)<any>`
    padding: 24px;
  `,

};
